<div class="overlay">
    <div class="loader-card">
      <img src="/assets/icons/loader.svg" alt="Loading..." />
      <div class="body-text-paragraph">{{ label }}</div>
    </div>
  </div>
  